import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { forwardRef } from "react";
import { Input } from "../Input/Input";
import styles from "./PasswordInput.module.css";

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	error?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
	({ className, error, ...props }, ref) => {
		const [show, setShow] = useState(false);
		return (
			<div className={styles.wrapper}>
				<Input
					ref={ref}
					type={show ? "text" : "password"}
					error={error}
					className={[styles.input, className].filter(Boolean).join(" ")}
					{...props}
				/>
				<button
					type="button"
					className={styles.toggle}
					onClick={() => setShow((s) => !s)}
					tabIndex={-1}
				>
					{show ? <EyeOff size={16} /> : <Eye size={16} />}
				</button>
			</div>
		);
	},
);
PasswordInput.displayName = "PasswordInput";
